import {
    Table,
    TableBody,
    TableContainer,
  } from '@mui/material'
import Paper from '@mui/material/Paper';
import { IBuilding } from '../../models/dashboard';
import DashboardRow from './DashboardRow';
import { useEffect, useState } from 'react';
import DashboardHeader from './DashboardHeader';
import useDashboardSelection from '../../hooks/UseDashboardSelection';
import Spinner from '../Spinner/Spinner';

const dashboardStyles = {
    main : {
        marginLeft : 5, 
        marginRight : 5
    }
}

const Dashboard = () => {
    const [nRow, setNRow] = useState(0);
    const {start,setStart,end,setEnd,buildingId,setBuildingId,buildings,buildingSelections, serverMessage,isLoading} = useDashboardSelection();

    useEffect(() => {
        const nRowDebug = buildings ? buildings.reduce(
            (acc,building) => building.locals.length > acc ? acc = building.locals.length : acc  ,0
        ) : 0;
        setNRow(
            nRowDebug
        );
    },[buildings])

    return (
            <>
                <header>
                    <DashboardHeader
                        key={buildingId} 
                        buildingId={buildingId} 
                        buildingSelections={buildingSelections} 
                        setBuildingId={setBuildingId} 
                        setStart={setStart} 
                        setEnd={setEnd} 
                        start={start} end={end}
                        />
                    {serverMessage && <p>{serverMessage}</p>}
                </header>
                {
                nRow > 0 && buildings.length && !isLoading ?
                <TableContainer {...dashboardStyles.main} component={Paper}>
                    <Table aria-label="scans table">
                        <TableBody>
                        {   
                            buildings.map((building: IBuilding, i) => (
                                <DashboardRow key={buildingId * i} building={building} nRow={nRow} />
                            ))
                        }
                        </TableBody>
                    </Table>
                </TableContainer> : <Spinner/>
                }
            </> 
    )
}

export default Dashboard;
